<template>
  <div class="user-index">
    <div class="info">
      <span>Users</span>
    </div>
    <div class="info">
      <btn
        name="Invite user"
        @click="createUser"
      />
    </div>
    <list
      :columns="columns"
      :items="filteredUsers"
      :buttons="buttons"
      @edit="edit"
      @delete="deleteUser"
    />
    <div class="info">
      <span>Pending invites</span>
    </div>
    <list
      :columns="pendingUsersColumns"
      :items="filteredUserInvites"
      :buttons="userInvitesButtons"
      @copyLink="copyLink"
      @deleteUserInvite="deleteUserInvite"
      @resendInvitation="resendInvitation"
    />
    <form-dialog
      v-if="formDialog"
      :item="item"
      :header="headerTitle"
      :buttons="formButtons"
      :disabled="disabled"
      @cancel="formDialog = false; editing = false;"
      @sendEmail="sendEmail"
      @getLink="getLink"
      @save="save"
      @resetMfa="resetMfa"
    >
      <div
        v-if="!editing"
        class="select"
      >
        <label class="label">App</label>
        <multiselect
          v-model="app"
          :options="apps"
          track-by="name"
          label="name"
          placeholder="Select app"
          :searchable="true"
        />
      </div>
      <div class="select">
        <label class="label">Group</label>
        <multiselect
          v-model="group"
          :options="groups"
          track-by="id"
          label="name"
          placeholder="Select group"
          :searchable="true"
          :allow-empty="true"
        />
      </div>
      <div
        v-if="!editing"
        class="select"
      >
        <label class="label">Role</label>
        <multiselect
          v-model="role"
          :options="app && app.roles || []"
          track-by="name"
          label="name"
          placeholder="Select role"
          :searchable="true"
        />
      </div>
    </form-dialog>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'UserIndex',
    components: {
      list: () => import('@/views/admin/components/list.vue'),
      btn: () => import('@/views/admin/components/btn.vue'),
      Multiselect,
      'form-dialog': () => import('@/views/admin/components/form-dialog.vue'),
    },
    props: {},
    data() {
      return {
        buttons: [{ name: 'Edit', callback: 'edit' }, { name: 'Delete', callback: 'delete' }],
        userInvitesButtons: [{ name: 'Copy link', callback: 'copyLink' }, { name: 'Resend mail', callback: 'resendInvitation' }, { name: 'Delete', callback: 'deleteUserInvite' }],
        app: null,
        role: null,
        group: null,
        mfa: false,
        previousGroup: null,
        formDialog: false,
        editing: false,
        userInvites: [],
        item: {
          name: { value: '' },
          email: { value: '' },
        },
        pendingUsersColumns: [
          {
            name: 'ID',
            key: 'id',
          },
          {
            name: 'Name',
            key: 'name',
          },
          {
            name: 'Email',
            key: 'email',
          },
          {
            name: 'App',
            key: 'app',
          },
          {
            name: 'Group',
            key: 'groupName',
          },
          {
            name: 'Role',
            key: 'role',
          },
        ],
        columns: [
          {
            name: 'ID',
            key: 'id',
          },
          {
            name: 'Name',
            key: 'name',
          },
          {
            name: 'Email',
            key: 'email',
          },
          {
            name: 'Disabled',
            key: 'disabled',
          },
          {
            name: 'MFA',
            key: 'mfa',
          },
          {
            name: 'Group',
            key: 'groupName',
          },
          {
            name: 'Apps',
            key: 'apps',
          },
        ],
      };
    },
    apollo: {
      userInvites: gql`
      query {
        userInvites {
          id
          email
          link
          name
          role {
            id
            name
            app {
              id
              name
            }
          }
          group {
            id
            name
          }
        }
      }
      `,
      apps: gql`
        query {
          apps {
            id
            name
            roles {
              id
              name
            }
          }
        }
      `,
      groups: gql`
        query {
          groups (orderBy: { name: asc }) {
            id
            name
          }
        }
      `,
      users: gql`query {
        users {
          id
          name
          email
          disabled
          mfa
          grants {
            id
            role {
              id
              name
              app {
                id
                name
              }
            }
          }
          group {
            id
            name
          }
        }
      }`,
    },
    computed: {
      disabled() {
        if (this.editing) {
          return this.item.name.value === '' || this.item.email.value === '';
        }
        return !this.app || !this.role || this.item.email.value === '';
      },
      formButtons() {
        if (this.editing) {
          return [
            ...(this.mfa ? [{ name: 'Reset MFA', callback: 'resetMfa' }] : []),
            { name: 'Save', callback: 'save' },
          ];
        }
        return [{ name: 'Send email', callback: 'sendEmail' }, { name: 'Get link', callback: 'getLink' }];
      },
      headerTitle() {
        return this.editing ? 'Edit user' : 'Invite user';
      },
      filteredUserInvites() {
        if (this.userInvites) {
          return this.userInvites.map((userInvite) => ({
            ...userInvite,
            app: userInvite.role.app.name,
            role: userInvite.role.name,
            groupName: userInvite.group && userInvite.group.name,
          }));
        }
        return [];
      },
      filteredUsers() {
        if (this.users) {
          return this.users.map((user) => ({
            ...user,
            apps: [...new Set(user.grants.map((grant) => grant.role.app.name))].join(),
            groupName: user.group && user.group.name,
          }));
        }
        return [];
      },
    },
    watch: {},
    mounted() {},
    methods: {
      save(item) {
        const addGroup = !!(!this.previousGroup && this.group);
        const removeGroup = !!(this.previousGroup && !this.group);
        this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id: String!
              $email: String!
              $name: String
              $disabled: Boolean
              ${addGroup ? '$groupId: String' : ''}
            ) {
              updateOneUser(
                where: {id: $id}
                data: {
                  email: { set: $email }
                  name: { set: $name }
                  disabled: { set: $disabled }
                  ${addGroup ? 'group: { connect: { id: $groupId } }' : ''}
                  ${removeGroup ? 'group: { disconnect: true }' : ''}
                }) {
                id
                name
              }
            }
          `,
          variables: {
            email: item.email.value,
            name: item.name.value,
            id: item.id.value,
            disabled: item.disabled.value,
            groupId: this.group && this.group.id,
          },
        }).then(() => {
          this.$apollo.queries.users.refetch();
          this.formDialog = false;
          this.editing = false;
        });
      },
      resetMfa(item) {
        if (window.confirm(`Are you sure you want to reset MFA for ${item.name.value}?`)) {
          this.$apollo.mutate({
            mutation: gql`
              mutation ($id: String!) {
                updateOneUser (
                  where: { id: $id }
                  data: {
                    mfa: { set: false }
                    mfaSecret: { set: null }
                  }
                )
                {
                  id
                }
              }
            `,
            variables: {
              id: item.id.value,
            },
          }).then(() => {
            this.mfa = false;
            this.$apollo.queries.users.refetch();
          });
        }
      },
      copyLink(item) {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(item.link);
        } else {
          alert(item.link);
        }
      },
      deleteUserInvite(item) {
        this.$apollo.mutate({
          mutation: gql`
            mutation($id: String!) {
              deleteOneUserInvite(where: {id: $id}) {id}
            }
          `,
          variables: {
            id: item.id,
          },
        }).then(() => {
          this.$apollo.queries.userInvites.refetch();
        });
      },
      resendInvitation(item) {
        this.$apollo.mutate({
          mutation: gql`
            mutation($userInviteId: String!) {
              resendUserInvite(userInviteId: $userInviteId) {
                id
              }
            }
          `,
          variables: {
            userInviteId: item.id,
          },
        }).then(() => {
          alert('Sent email');
        });
      },
      getLink(item) {
        this.createUserInvite(
          item.email.value,
          this.role.id,
          this.app.id,
          false,
          item.name.value,
          this.group && this.group.id,
        );
      },
      sendEmail(item) {
        this.createUserInvite(
          item.email.value,
          this.role.id,
          this.app.id,
          true,
          item.name.value,
          this.group && this.group.id,
        );
      },

      createUserInvite(email, roleId, appId, sendEmail, name, groupId) {
        this.$apollo.mutate({
          mutation: gql`
            mutation($email: String!, $roleId: String!, $appId: String!, $sendEmail: Boolean, $name: String, $groupId: String) {
              createUserInvite(email: $email, roleId: $roleId, appId: $appId, sendEmail: $sendEmail, name: $name, groupId: $groupId) {
                id
                email
                link
                name
                group {
                  id
                  name
                }
              }
            }
          `,
          variables: {
            email, roleId, appId, sendEmail, name, groupId,
          },
        }).then(({ data: { createUserInvite } }) => {
          if (sendEmail) {
            alert('Sent email');
          } else {
            this.copyLink(createUserInvite);
          }
          this.$apollo.queries.users.refetch();
          this.$apollo.queries.userInvites.refetch();
          this.formDialog = false;
        });
      },

      deleteUser(item) {
        if (window.confirm('Are you sure you want to delete user?')) {
          this.$apollo.mutate({
            mutation: gql`
                  mutation($id: String!) {
                    deleteUser(id: $id) {
                      id
                    }
                  }
            `,
            variables: {
              id: item.id,
            },
          }).then(() => {
            this.$apollo.queries.users.refetch();
          });
        }
      },
      edit(item) {
        Object.assign(this.item, {
          id: { value: item.id, disabled: true },
          name: { value: item.name },
          email: { value: item.email },
          disabled: { value: item.disabled, type: 'checkbox' },
        });
        this.group = item.group;
        this.mfa = item.mfa;
        this.previousGroup = item.group;
        this.formDialog = true;
        this.editing = true;
      },
      createUser() {
        this.item = {
          name: { value: '' },
          email: { value: '' },
        };
        this.group = null;
        this.formDialog = true;
        this.editing = false;
      },
    },
  };
</script>


<style lang="stylus" scoped>
  .select
    margin-bottom: 20px
</style>
